
<div>
  <GenericError v-if="hasError" class="mt-48">
    There was an error creating your profile. All of your information has been saved. Refresh the page to try again or
    <a class="link-secondary underline" href="https://support.sittercity.com/hc/en-us/requests/new" target="_blank"
      >contact us</a
    >
    if the issue continues.
  </GenericError>
  <FormStepper
    v-else
    :steps="steps"
    progressBarTitle="Building profile"
    progressBarLastStepTitle="Last profile step!"
    :loading="loading"
    @submit="handleSubmit"
  >
    <template #progressBar="{ currentStep, maxSteps }">
      <div class="flex gap-16 mt-16">
        <ProgressBar :value="currentStep" :max="maxSteps" content="Building Profile" />
        <ProgressBar :value="0" :max="3" content="Verifying Identity" />
      </div>
    </template>
  </FormStepper>
</div>
